import { render, staticRenderFns } from "./JobStatusCell.vue?vue&type=template&id=06db0c77&"
import script from "./JobStatusCell.vue?vue&type=script&lang=js&"
export * from "./JobStatusCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports